import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { Motif } from '@shared/models/motif.model';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-default-popup',
  templateUrl: './default-popup.component.html',
  styleUrls: ['./default-popup.component.scss'],
  standalone: false,
})
export class DefaultPopupComponent {
  // Tells you if you can type the motif yourself or choose an option
  public canTypeMotif: boolean = false;

  public title: string;

  public description: string;

  public type: string = 'close'; // Available default, close

  public buttons: any[];

  public motifs?: Motif[];

  public selectedMotif: string = '';

  public closeDelete: boolean = false;

  public showMotifs: boolean = true;

  public selectedChoice: string = 'close';

  public originButtons: any[] = [];

  public deleteButtons: any = [];

  public hospitalNames: HospitalNames;

  constructor(
    public dialogRef: MatDialogRef<DefaultPopupComponent>,
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = this.data.title;
    this.description = this.data.description;
    this.type = this.data.type;
    this.buttons = this.data.buttons;
    this.motifs = this.data.motifs ?? null;
    this.motifs?.sort((a, b) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    this.closeDelete = this.data.closeDelete;
    this.originButtons = this.data.buttons;
    this.selectedMotif = this.data.selectedMotif || '';
    this.deleteButtons = [
      { value: false, name: 'Annuler', type: 'text', color: 'primary' },
      { value: true, name: 'Oui, supprimer', type: 'primary', color: 'danger' },
    ];
    this.hospitalNames = this.userService.getHospitalNames();
  }

  onChoiceChange(value: string): void {
    this.showMotifs = value === 'close';
    this.selectedChoice = value;
    this.buttons = this.showMotifs ? this.originButtons : this.deleteButtons;
  }

  close(data: any): void {
    this.dialogRef.close(
      this.motifs ? { data: data, selectedMotif: this.selectedMotif, closeDelete: this.showMotifs } : data
    );
  }

  toggleCanTypeMotif() {
    this.canTypeMotif = !this.canTypeMotif;
  }

  selectedMotifChange(motif: string) {
    this.selectedMotif = motif;
  }
}
